// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo_logo__1LJl2","large":"logo_large__DdbTD","logoImage":"logo_logoImage__2XjHL","footerLogo":"logo_footerLogo__3NW31"};